import { FC, useEffect, useState } from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'

import { authSelector } from '@/modules/Auth/store/AuthSelector'
import { getUserThunk } from '@/modules/Auth/store/AuthSlice'

import { useHandleServerError } from '@/hooks/useHandleServerError'

import { Private } from '@/components/Layout/Private'
import { Loading } from '@/components/UI/Loading'

import { useAppDispatch, useAppSelector } from './store/hooks'

export const PrivateRoute: FC = () => {
  const dispatch = useAppDispatch()
  const isAuth = useAppSelector(authSelector)
  const { handleServerError } = useHandleServerError()
  const navigate = useNavigate()

  const [isLoading, setLoading] = useState<boolean>(true)

  const getUser = async () => {
    try {
      await dispatch(getUserThunk()).unwrap()

      setLoading(false)
    } catch (error) {
      setLoading(false)
      handleServerError(error)
      localStorage.removeItem('token')
      navigate('/login')
    }
  }

  useEffect(() => {
    getUser()
  }, [])

  if (isLoading && !isAuth) return <Loading type='circle' />

  return isAuth ? (
    <Private>
      <Outlet />
    </Private>
  ) : (
    <Navigate to={'/login'} />
  )
}
